import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { plainToClass } from 'class-transformer';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map, tap, timeout } from 'rxjs/operators';
import { RestService } from 'src/app/shared/service/rest.service';
import { TenantInfo } from '../model/tenant-info';
import { ViolationAggregate } from '../model/violations-aggregate';
import { SessionStorageService } from '../../common/service/session-storage.service';
import { SakpModuleUtils } from '../sakp-module-utils';


@Injectable()
export class ViolationService extends RestService {
    public static readonly SOURCE = 'violations';
    private static readonly STORAGE_NAME = 'sakp-violations';
    private dataSubject: BehaviorSubject<ViolationAggregate[]> = new BehaviorSubject([]);


    constructor(http: HttpClient, private sessionStorageService: SessionStorageService) {
        super(http);
        this.serverUrl = SakpModuleUtils.getSakpServerUrl();
        const data = this.sessionStorageService.getItemArray<ViolationAggregate>(ViolationService.STORAGE_NAME, ViolationAggregate);
        if (data != null)
            this.dataSubject.next(data);
    }

    initiate(tenant: TenantInfo): Observable<ViolationAggregate[]> {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        return this.doGet('api/v1/dict/violations', null, { 'X-Tenant-ID': tenant.id.toString() })
            .pipe(
                timeout(5000),
                map((res: any[]) => plainToClass(ViolationAggregate, res)),
                map(res => res.sort((a, b) => a.since.getTime() - b.since.getTime())),
                tap(data => {
                    this.dataSubject.next(data);
                    this.sessionStorageService.setItem(ViolationService.STORAGE_NAME, data);
                }),
                catchError(err => {
                    this.dataSubject.next([]);
                    this.sessionStorageService.setItem(ViolationService.STORAGE_NAME, []);
                    err.source = ViolationService.SOURCE;
                    return throwError(err);
                })
            );
    }

    getAll(): ViolationAggregate[] {
        return this.dataSubject.getValue() || [];
    }

    getByDate(date: Date): ViolationAggregate | null {
        const d = new Date(date);
        d.setHours(0, 0, 0, 0);
        return this.getAll().find(q => {
            const qs = new Date(q.since);
            qs.setHours(0, 0, 0, 0);
            if (qs > d) return false;
            if (q.until == null) return true;
            const qu = new Date(q.until);
            qu.setHours(0, 0, 0, 0);
            return qu > d;
            // FIXME: nie zwraca poprawnego zestawu, bo patrzy na godziny, a te mogą być przesunięte. Powinno szukać tylko po dacie.
            // return q.since.setTime(0) <= date.setTime(0) && (q.until == null || q.until.setTime(0) > date.setTime(0));
        }) || null;
    }

    clear(): void {
        this.sessionStorageService.setItem(ViolationService.STORAGE_NAME, []);
        this.dataSubject.next([]);
    }

}
